import React from 'react';
import { MenuItem, Select, InputLabel } from '@mui/material';
import { Environments } from "@beable/roster-backend-client-v1";

interface EnvironmentSelectProps {
    onChange: (e: any) => void;
    disabled?: boolean;
    env?: Environments | undefined;
    labelText?: string;
}
  
export default function EnvironmentSelector({ onChange, disabled, env, labelText }: EnvironmentSelectProps) {
    return <>
    { labelText && (<InputLabel id="environmentPickerLabel" htmlFor="environmentPicker">{labelText}</InputLabel>) }
    <Select
        variant="standard"
        labelId="environmentPickerLabel"
        id="environmentPicker"
        name="environment"
        value={env}
        onChange={onChange}
        disabled={disabled}>
        {Object.keys(Environments).map((e) => <MenuItem value={e} key={e}>{e}</MenuItem>)}
    </Select>
    </>;
}
